import React from 'react'
import { Typography, Image } from 'antd';
import crossImg from "./cross.jpg"
import lightImg from "./light.jpg"
import mainImg from "./main.jpg"
import modelImg from "./model.jpg"
import posteffeImg from "./posteffe.jpg"
import renderImg from "./render.jpg"
import roadtexImg from "./roadtex.jpg"
import sectionImg from "./section.jpg"
import specialImg from "./special.jpg"
import systemImg from "./system.jpg"
import terrImg from "./terr.jpg"
import weatherImg from "./weather.jpg"
const { Title, Paragraph, Text, Link } = Typography;

export default function Widget() {
  return (
    <Typography>
      <Title level={2}>主界面</Title> 
      <Paragraph>
        主界面主要包括四个区域，左边区域为功能菜单界面，如<Text mark>打开、保存、地形、天气、光照、道路材质、后效、渲染</Text>等，右上角区域为场景管理器，
        主要任务是对场景中成百上千的物体进行<Text mark>增、删、改、查</Text>操作，下方区域为景观布置，分<Text mark>单个、线性、区域、智能</Text>等多
        种布置方式，上方区域为道路模型参数修改，包括<Text mark>道路横断面、特殊路段公交站尺寸和曲线参数、交叉口渠化</Text>的各个尺寸等。
      </Paragraph>     
      <Image width={500} src={mainImg} />
      <Title level={2}>系统菜单</Title>
      <Image width={100} src={systemImg} /> 
      <Title level={2}>地形编辑</Title>
      <Image width={100} src={terrImg} /> 
      <Title level={2}>道路材质</Title>
      <Image width={500} src={roadtexImg} /> 
      <Title level={2}>天气系统</Title>
      <Image width={100} src={weatherImg} /> 
      <Title level={2}>灯光照明</Title>
      <Image width={100} src={lightImg} /> 
      <Title level={2}>后期特效</Title>
      <Image width={100} src={posteffeImg} /> 
      <Title level={2}>渲染导出</Title>
      <Image width={100} src={renderImg} /> 
      <Title level={2}>景观布置</Title>
      <Image width={500} src={modelImg} /> 
      <Title level={2}>道路横断面</Title>
      <Image width={500} src={sectionImg} /> 
      <Title level={2}>交叉口渠化</Title>
      <Image width={500} src={crossImg} /> 
      <Title level={2}>特殊路段尺寸</Title>
      <Image width={500} src={specialImg} /> 
    </Typography>
  )
}
